module.exports = __webpack_public_path__ + "2d955a2ce787663223e60d5cf958c658.png";